import React from "react";
import { RankingProcessImg } from "../../shared/icons";
import Accordion from "../../components/shared-components/accordions/Accordion";
import styled from "styled-components";
import { screenSizes } from "../../styles/theme";

const RankingProcessWrapper = styled.div`
  margin: 40px 0px;
  @media (max-width: ${screenSizes.L}px) {
    margin: 0;
  }
  h4 {
    color: rgba(9, 28, 0, 1);
    font-family: Manrope;
    font-size: 50px;
    font-weight: 700;
    line-height: 64px;
    letter-spacing: -2px;
    margin-bottom: 30px;
    @media (max-width: ${screenSizes.L}px) {
      margin: 0;
      font-size: 32px;
    }
  }
`;

const RankingProcessGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  img {
    height: 596px;
    width: 100%;
    @media (max-width: ${screenSizes.L}px) {
      height: 350px;
      margin-bottom: 10px;
    }
  }
  @media (max-width: ${screenSizes.L}px) {
    display: block;
  }
`;

const RankingProcess = () => {
  const accordionData = [
    {
      id: 1,
      title: "Carbon Offset",
      content:
        "Carbon offsetting for Digital Assets is an innovative approach to mitigate the environmental impact of digital art and collectibles. By investing in renewable energy projects or reforestation initiatives, Digital Asset creators and collectors can balance out the carbon emissions generated during the minting and trading processes. This not only helps in promoting sustainability but also enhances the value of the Digital Assets by aligning them with eco-friendly practices. As the Digital Asset market grows, embracing carbon offset strategies will be crucial in ensuring a greener future for digital assets.",
    },
    {
      id: 2,
      title: "Transaction Efficieny",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis",
    },
    {
      id: 3,
      title: "Social Donations",
      content:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis",
    },
  ];
  return (
    <RankingProcessWrapper>
      <h4>AI Ranking Process</h4>
      <RankingProcessGrid>
        <img
          src={RankingProcessImg}
          alt=""
        />
        <div>
          {accordionData?.map((accordion: any, index:any) => (
            <Accordion
              key={accordion?.id}
              title={accordion?.title}
              content={accordion?.content}
              defaultOpen={index === 0}
            />
          ))}
        </div>
      </RankingProcessGrid>
    </RankingProcessWrapper>
  );
};

export default RankingProcess;
